export default {
      id: "gps_fixed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#gps_fixed",
      toString: function () {
        return this.url;
      }
    }